import React from 'react';
import { useReveal } from '../lib/useReveal';
const SYMPTOMS = [{
  emoji: '😔',
  text: 'Cansancio emocional constante'
}, {
  emoji: '🧠',
  text: 'Estrés mental acumulado'
}, {
  emoji: '⚡',
  text: 'Sensación de desbalance energético'
}, {
  emoji: '🔄',
  text: 'Necesidad de reinventarte'
}, {
  emoji: '🌱',
  text: 'Búsqueda espiritual'
}];
export function ProblemSection() {
  const [ref1, vis1] = useReveal();
  return <section className="bg-[#1a1a2e] py-14 md:py-20 px-4 relative overflow-hidden border-t border-white/5" data-id="element-390">
      <div className="container mx-auto max-w-3xl relative z-10" data-id="element-391">
        <div ref={ref1} className={`reveal text-center ${vis1 ? 'is-visible' : ''}`} data-id="element-392">
          <h2 className="text-3xl md:text-5xl font-serif font-bold mb-6 leading-tight text-white" data-id="element-393">
            Si llegaste hasta aquí
            <br data-id="element-394" />
            probablemente algo dentro tuyo
            <br data-id="element-395" />
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#d4a017] via-[#f0c040] to-[#d4a017]" data-id="element-396">
              está buscando equilibrio.
            </span>
          </h2>

          {/* Subtitle */}
          <div className="space-y-2 text-lg md:text-xl text-gray-300 leading-relaxed max-w-2xl mx-auto mb-8" style={{
          fontFamily: "'Cormorant Garamond', serif",
          fontWeight: 500
        }} data-id="element-397">
            <p data-id="element-398">
              El estrés, el cansancio emocional
              <br data-id="element-399" />
              y los bloqueos energéticos
              <br data-id="element-400" />
              se acumulan con el tiempo.
            </p>
            <p className="pt-2" data-id="element-401">
              Muchas personas descubren el Reiki
              <br data-id="element-402" />
              cuando sienten que necesitan
              <br data-id="element-403" />
              <span className="text-white font-semibold" data-id="element-404">
                reconectar con su energía.
              </span>
            </p>
          </div>

          {/* Symptom cards */}
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 max-w-2xl mx-auto text-left" data-id="element-405">
            {SYMPTOMS.map((item, idx) => <div key={idx} className={`flex items-center gap-4 bg-[#252538] p-5 rounded-xl border border-white/10 shadow-sm ${idx === SYMPTOMS.length - 1 ? 'sm:col-span-2 sm:max-w-sm sm:mx-auto' : ''}`} data-id="element-406">
                <span className="text-2xl flex-shrink-0" data-id="element-407">{item.emoji}</span>
                <span className="text-lg text-gray-200 font-medium" data-id="element-408">
                  {item.text}
                </span>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}